module.exports = __webpack_public_path__ + "img/friss-logo-full-color.4b2b89fd.svg";